angular.module('pitch.app').controller('NewsCtrl',
    function($scope, ContentsLoader, SiteContext) {
        "use strict";

        SiteContext.get().then(function(r) {
            $scope.newsLoader = new ContentsLoader({
                sortField: 'date',
                sortOrder: 'DESC',
                category: 'news',
                namespace: '/,sites/' + r.id
            }).onLoad(function(r) {
                $scope.featuredItems = r.slice(0, 2);
            }).getFirstPage();
        });
    }
);



// WEBPACK FOOTER //
// ./src/AppBundle/Resources/js/angular/controllers/NewsCtrl.js